import clsx from 'clsx'
import { useState, type ReactNode } from 'react'
import { View } from 'react-native'

import { Image, type TImageProps } from '@/src/elements/image'

export const PublicationCoverImage = ({ className, ...otherProps }: TImageProps): ReactNode => {
  const [width, setWidth] = useState(0)
  const [height, setHeight] = useState(0)

  return (
    <View className="my-2 max-w-full" style={{ aspectRatio: width && height ? width / height : 16 / 9 }}>
      <Image
        radius="lg"
        className={clsx('mx-auto w-full', className)}
        onLoad={({ source }) => {
          if (!width) {
            setWidth(source.width)
          }
          if (!height) {
            setHeight(source.height)
          }
        }}
        {...otherProps}
      />
    </View>
  )
}
